module.exports = __webpack_public_path__ + "img/organization.83cc6612.png";